import { UnitActivationStatus, UnitActivationStatusDescription } from '@apps-common/config/unit-activation'

export const getUnitActivationStatusDescription = (status?: string | null): string => {
  const key = status as UnitActivationStatus
  return UnitActivationStatusDescription[key] ?? UnitActivationStatusDescription.unknown
}
